import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, errorMessage } from '../../context/AuthContext';

export default function AdminArticles() {
  const { authFetch } = useAuth();
  const [items, setItems] = useState([]);

  const [loadError, setLoadError] = useState(false);
  const load = () => authFetch('/api/articles/admin')
    .then(r => r.ok ? r.json() : Promise.reject())
    .then(d => { setItems(d); setLoadError(false); })
    .catch(() => setLoadError(true));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const del = async (id) => {
    if (!window.confirm('Supprimer cet article ?')) return;
    try {
      const r = await authFetch(`/api/articles/${id}`, { method: 'DELETE' });
      if (!r.ok) throw new Error(await errorMessage(r));
    } catch (e) {
      alert(`Suppression impossible : ${e.message}`);
    }
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h1 style={{ fontStyle: 'italic' }}>Articles</h1>
        <Link to="/admin/articles/new" className="btn">+ nouvel article</Link>
      </div>
      <div className="admin-list">
        {loadError && <div className="flash error">Impossible de charger la liste — rechargez la page.</div>}
        {!loadError && items.length === 0 && <div className="empty-state">aucun article.</div>}
        {items.map(a => (
          <div className="admin-row" key={a.id}>
            <div>
              <div className="admin-row-title">{a.title}</div>
              <div style={{ fontSize: '.8rem', color: 'var(--ink-soft)', fontFamily: 'var(--font-mono)' }}>
                /{a.slug} · {a.published ? '✓ publié' : '⏸ brouillon'}
              </div>
            </div>
            <div className="admin-row-actions">
              <Link to={`/admin/articles/${a.id}`} className="btn secondary">éditer</Link>
              <button className="btn danger" onClick={() => del(a.id)}>supprimer</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
